import * as Sentry from '@sentry/nextjs';
import { trackApiError, trackGraphQLError } from './sentryUtils';

/**
 * Legacy compatibility function for the old reportError
 * This function now only reports to Sentry without showing snackbar notifications
 */
export const reportErrorToSentry = (
  error?: any,
  context?: {
    title?: string;
    detail?: string;
    endpoint?: string;
    method?: string;
    operation?: string;
    component?: string;
    action?: string;
  }
) => {
  // If no error object is provided, create a generic error from the title
  const errorToReport = error || new Error(context?.title || 'Unknown error occurred');

  // Track different types of errors in Sentry
  if (context?.endpoint) {
    // API error
    trackApiError(errorToReport, context.endpoint, context.method);
  } else if (context?.operation) {
    // GraphQL error
    trackGraphQLError(errorToReport, context.operation);
  } else {
    // Generic error
    Sentry.withScope((scope) => {
      if (context?.component) {
        scope.setTag('component', context.component);
      }
      if (context?.action) {
        scope.setTag('action', context.action);
      }
      if (context?.title) {
        scope.setTag('errorTitle', context.title);
      }
      if (context?.detail) {
        scope.setContext('errorDetail', { detail: context.detail });
      }
      scope.setLevel('error');
      Sentry.captureException(errorToReport);
    });
  }

  // Log to console in development for debugging
  if (process.env.NODE_ENV === 'development') {
    console.error('Error reported to Sentry:', errorToReport, context);
  }
};

/**
 * Backward compatibility function that matches the old reportError signature
 * but only reports to Sentry without showing notifications to users
 */
export const reportError = (
  title?: string,
  detail?: string,
  error?: any,
  context?: { endpoint?: string; method?: string }
) => {
  reportErrorToSentry(error, {
    title,
    detail,
    ...context,
  });
};
